import {
	isHongKongResident,
	countOffersMatchingPlan,
	countOffersMatchingPlanWithLoadingsOnly,
	countOffersMatchingPlanWithExclusionsOnly,
	countOffersMatchingPlanWithLoadingsAndExclusions,
	countOffersMatchingPlanWithRejectedStatus
} from "./helpers.js"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

const header = [
	[
		"Template 02 - Number of applications by five underwriting/ re-underwriting, by place of Residence of Insured Person"
	],
	[
		"Place of Residence",
		"Standard Plan",
		"",
		"",
		"",
		"",
		"Flexi Plan",
		"",
		"",
		"",
		""
	],
	[
		"",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline",
		"Standard Offer",
		"Offer with Premium Loading only",
		"Offer with CBE only",
		"Offer with Premium Loading and CBE",
		"Decline"
	]
]

const rows = cases => [
	[
		"Hong Kong",
		countStandardOffer(true, cases, "S00027"),
		countOfferWithLoadings(true, cases, "S00027"),
		countOfferWithExclusions(true, cases, "S00027"),
		countOfferWithLoadingsAndExclusions(true, cases, "S00027"),
		countDeclinedOffers(true, cases, "S00027"),
		countStandardOffer(true, cases, "F00038"),
		countOfferWithLoadings(true, cases, "F00038"),
		countOfferWithExclusions(true, cases, "F00038"),
		countOfferWithLoadingsAndExclusions(true, cases, "F00038"),
		countDeclinedOffers(true, cases, "F00038")
	],
	[
		"Others",
		countStandardOffer(false, cases, "S00027"),
		countOfferWithLoadings(false, cases, "S00027"),
		countOfferWithExclusions(false, cases, "S00027"),
		countOfferWithLoadingsAndExclusions(false, cases, "S00027"),
		countDeclinedOffers(false, cases, "S00027"),
		countStandardOffer(false, cases, "F00038"),
		countOfferWithLoadings(false, cases, "F00038"),
		countOfferWithExclusions(false, cases, "F00038"),
		countOfferWithLoadingsAndExclusions(false, cases, "F00038"),
		countDeclinedOffers(false, cases, "F00038")
	]
]

const countStandardOffer = (isPlaceOfResidence, cases, plan) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countOffersMatchingPlan(item?.proposals, plan)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithLoadings = (isPlaceOfResidence, cases, plan) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countOffersMatchingPlanWithLoadingsOnly(
			item?.proposals,
			plan
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithExclusions = (isPlaceOfResidence, cases, plan) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countOffersMatchingPlanWithExclusionsOnly(
			item?.proposals,
			plan
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countOfferWithLoadingsAndExclusions = (
	isPlaceOfResidence,
	cases,
	plan
) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countOffersMatchingPlanWithLoadingsAndExclusions(
			item?.proposals,
			plan
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const countDeclinedOffers = (isPlaceOfResidence, cases, plan) => {
	const filteredCases = cases.map(item => {
		let address = item?.insureds?.[0]?.addresses
		let resident = isHongKongResident(address)
		let countOffers = countOffersMatchingPlanWithRejectedStatus(
			item?.proposals,
			plan
		)
		if (resident === isPlaceOfResidence) {
			return countOffers
		} else return 0
	})
	return filteredCases?.reduce((total, item) => {
		return (total += item)
	}, 0)
}

const fetchData = async filterPayload => {
	const query = gql`
		query fetchTemplate02Payload($caseWhere: caseWhere) {
			cases(where: $caseWhere) {
				list {
					id
					insureds {
						... on individual {
							addresses {
								type
								fields2 {
									type
									value
								}
							}
						}
					}
					proposals {
						id
						status
						basket {
							product {
								productId {
									plan
								}
							}
							premium {
								loadings {
									id
								}
							}
							exclusions {
								id
							}
						}
					}
				}
			}
		}
	`

	const variables = {
		caseWhere: filterPayload
	}

	const res = await api({ query, variables })

	return res?.data?.cases?.list
}

export default async filterPayload => {
	const fetchedData = await fetchData(filterPayload)
	const workSheetData = [...header, ...rows(fetchedData)]
	const workSheetColumns = header[2].map(item => {
		return { wpx: 100 }
	})
	const workSheetMerges = [
		{
			s: { r: 0, c: 0 },
			e: { r: 0, c: 6 }
		},
		{
			s: { r: 1, c: 0 },
			e: { r: 2, c: 0 }
		},
		{
			s: { r: 1, c: 1 },
			e: { r: 1, c: 5 }
		},
		{
			s: { r: 1, c: 6 },
			e: { r: 1, c: 10 }
		}
	]
	return { workSheetData, workSheetColumns, workSheetMerges }
}
